import "./LogoBand.css";
import { asset } from "../config";

/**
 * The 5 partner logos, national -> local (council logo intentionally excluded).
 * Heights are optical (sized by visual weight, not raw pixels) so the dense
 * crest doesn't dominate the airy wordmarks. The LLR partnership mark has
 * white artwork, so it sits on a purple card.
 */
type Logo = {
  file: string;
  alt: string;
  height: number;
  purple?: boolean;
};

// NHS ICB mark now lives in the header; the partner strip carries the other 4.
const LOGOS: Logo[] = [
  { file: "funded-by-uk-gov-logo.png", alt: "Funded by UK Government", height: 24 },
  {
    file: "LLR-Logo.png",
    alt: "Leicester, Leicestershire and Rutland partnership",
    height: 28,
    purple: true,
  },
  { file: "WorkWell-Logo.png", alt: "WorkWell", height: 28 },
  { file: "connect-to-work-logo.jpg", alt: "Connect to Work", height: 26 },
];

export function LogoBand() {
  return (
    <div className="logo-band" role="group" aria-label="Funded and delivered in partnership with">
      {LOGOS.map((logo) => (
        <img
          key={logo.file}
          className={`logo-band__img${logo.purple ? " logo-band__img--purple" : ""}`}
          src={asset(`logos/${logo.file}`)}
          alt={logo.alt}
          style={{ height: logo.height }}
        />
      ))}
    </div>
  );
}
